<template>
    <painel titulo="Analisar Justificativa" icon="pi pi-copy" :mostrarRefresh="false">
        <TabelaAnexos :anexos="anexos" />
        <h6 class="heading-1">
            <span>Analisar Justificativa</span>
        </h6>
        <btn-voltar class="mt-2" @click="voltar()" />

        <btn-aprovar class="ml-2" @voltarParaDetalhamento="voltar()" />
        <btn-ajustar class="ml-2" @voltarParaDetalhamento="voltar()" />
    </painel>
</template>

<script>
import BtnAprovar from './BtnAprovar.vue';
import BtnAjustar from './BtnAjustar.vue';
import SolicitacoesService from '../../services';
import TabelaAnexos from '../../detalhamento/TabelaAnexos.vue';

export default {
    components: {
        BtnAprovar,
        BtnAjustar,
        TabelaAnexos,
    },
    data() {
        return {
            anexos: [],
        };
    },
    mounted() {
        this.obterAnexos();
    },
    methods: {
        voltar() {
            this.$router.push({
                name: 'Licitacoes_Solicitacoes_Detalhar',
                params: { id: this.$route.params.id },
            });
        },
        async obterAnexos() {
            this.$store.dispatch('addRequest');
            SolicitacoesService.obterAnexos(this.$route.params.id).then((response) => {
                this.anexos = response && response.success ? response.data : null;
            });
            this.$store.dispatch('removeRequest');
        },
    },
};
</script>
